import {getQuery, removeQuery, postQuery} from "@/modules/common/utils";

const baseUrl = 'business/clients/v1/matters';

const list = (matterUid, params) => getQuery(`${baseUrl}/${matterUid}/notes`, Object.assign(params, {new_api: true}));

const remove = (matterUid, noteUid) => removeQuery(`${baseUrl}/${matterUid}/notes/${noteUid}`, {new_api: true});

const add = (matterUid, note) => postQuery(`${baseUrl}/${matterUid}/notes`, {note, new_api: true});

const get = (matterUid, noteUid) => getQuery(`${baseUrl}/${matterUid}/notes/${noteUid}`, {new_api: true});

export default {
  list,
  remove,
  add,
  get
}
